/**
 * 増殖したフォームアシストのボタンを消す。
 * - フォームアシストのボタンはcustom element <faimgdiv>
 * - 最初の一つ以外を消す
 */
export function cullFormAssist() {
  const formAssistElements = document.querySelectorAll("faimgdiv");

  // 最初の要素以外を削除
  for (let i = 1; i < formAssistElements.length; i++) {
    formAssistElements[i].remove();
  }
}

/**
 * MutationObserverを使って、フォームアシストのボタンが増殖したら消す
 */
export function observeCullFormAssist() {
  // console.debug("observeCullFormAssist: Start observing for form assist elements");
  const observer = new MutationObserver((mutations) => {
    const shouldCull = mutations.some((mutation) => {
      // 追加されたノードの中にfaimgdiv要素があるかどうかをチェック
      return Array.from(mutation.addedNodes).some((node) => {
        return node.nodeType === Node.ELEMENT_NODE && (node.tagName === "FAIMGDIV" || node.querySelector("faimgdiv"));
      });
    });

    if (shouldCull) {
      // console.debug("observeCullFormAssist: Mutation detected", mutations);
      cullFormAssist();
    }
  });

  // bodyを監視対象とし、子要素の追加を監視
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return observer;
}

/**
 * turbo:loadイベントでobserverを登録、turbo:before-cacheイベントでobserverを停止
 */
export function registerFormAssistObserver() {
  document.addEventListener("turbo:load", () => {
    const observer = observeCullFormAssist();
    document.addEventListener(
      "turbo:before-cache",
      () => {
        observer.disconnect();
      },
      { once: true },
    );
  });
}
